import _reducer from './reducer';
import * as _actions from './actions';

export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/CoveredInClass/Template/index.js